export default {
  // Options.jsx
  items_per_page: '条/页',
  jump_to: '跳至',
  page: '页',

  // Pagination.jsx
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页'
};


//////////////////
// WEBPACK FOOTER
// ./~/rc-pagination/es/locale/zh_CN.js
// module id = 2494
// module chunks = 0